
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faUser, faPlus
} from '@fortawesome/free-solid-svg-icons';


import '../global.css';
import '../components/Theme.css';
import './Card.css';

const Card = () =>{
    return(
        <div className="container mt-6">
            <div className="row">
                <div className="col-lg-3">
                    <div className="card card-box card-primary">
                        <div className="card-body">
                            <div className="row align-irems-center">
                                <div className="col">
                                    <h6>Total Profit</h6>
                                    <p className="h4">$240</p>
                                </div>
                                <div className="col-auto">
                                    <FontAwesomeIcon icon={faUser} className="" />
                                </div>
                            </div>
                            <div className="mt-4">
                                <p className="text-white mb-0 h6">From Previous Month</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="card card-box card-secondary">
                        <div className="card-body">
                            <div className="row align-irems-center">
                                <div className="col">
                                    <h6>Total Profit</h6>
                                    <p className="h4">$240</p>
                                </div>
                                <div className="col-auto">
                                    <FontAwesomeIcon icon={faUser} className="" />
                                </div>
                            </div>
                            <div className="mt-4">
                                <p className="text-white mb-0 h6">From Previous Month</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="card card-box card-info">
                        <div className="card-body">
                            <div className="row align-irems-center">
                                <div className="col">
                                    <h6>Total Profit</h6>
                                    <p className="h4">$240</p>
                                </div>
                                <div className="col-auto">
                                    <FontAwesomeIcon icon={faUser} className="" />
                                </div>
                            </div>
                            <div className="mt-4">
                                <p className="text-white mb-0 h6">From Previous Month</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="card card-box card-warning">
                        <div className="card-body">
                            <div className="row align-irems-center">
                                <div className="col">
                                    <h6>Total Profit</h6>
                                    <p className="h4">$240</p>
                                </div>
                                <div className="col-auto">
                                    <FontAwesomeIcon icon={faUser} className="" />
                                </div>
                            </div>
                            <div className="mt-4">
                                <p className="text-white mb-0 h6">From Previous Month</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="card card-box card-danger">
                        <div className="card-body">
                            <div className="row align-irems-center">
                                <div className="col">
                                    <h6>Total Profit</h6>
                                    <p className="h4">$240</p>
                                </div>
                                <div className="col-auto">
                                    <FontAwesomeIcon icon={faUser} className="" />
                                </div>
                            </div>
                            <div className="mt-4">
                                <p className="text-white mb-0 h6">From Previous Month</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="card card-box card-success">
                        <div className="card-body">
                            <div className="row align-irems-center">
                                <div className="col">
                                    <h6>Total Profit</h6>
                                    <p className="h4">$240</p>
                                </div>
                                <div className="col-auto">
                                    <FontAwesomeIcon icon={faUser} className="" />
                                </div>
                            </div>
                            <div className="mt-4">
                                <p className="text-white mb-0 h6">From Previous Month</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-4">
                    <div className="card">
                        <div className="card-block">
                            <div className="row mb-20">
                                <div className="col-auto">
                                    <img class="img-50 rounded-circle p-0" alt="Profile" src="./profile.jpg" />
                                </div>
                                <div className="col">
                                    <h5 className="m-0">Mukesh Kumar</h5>
                                    <span className="m-0 f-12">Magento Developer</span>
                                </div>
                            </div>
                            <p className="f-14 m-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="card">
                        <div className="icon-card position-relative">
                            <h5 className="mt-10">Mukesh Kumar</h5>
                            <p className="paragraph f-14 mb-0 mt-3">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                            <FontAwesomeIcon icon={faUser} className="bg-primary text-white" />
                        </div>    
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="h5">Multiple Images</h3>
                        </div>
                        <div className="card-block multiple-image">
                            <img className="img-40 rounded-circle" alt="Profile" src="./profile.jpg" />
                            <img className="img-40 rounded-circle -ml-10" alt="Profile" src="./profile.jpg" />
                            <img className="img-40 rounded-circle -ml-10" alt="Profile" src="./profile.jpg" />
                            <img className="img-40 rounded-circle -ml-10" alt="Profile" src="./profile.jpg" />
                            <img className="img-40 rounded-circle -ml-10" alt="Profile" src="./profile.jpg" />
                            <img className="img-40 rounded-circle -ml-10" alt="Profile" src="./profile.jpg" />
                            <img className="img-40 rounded-circle -ml-10" alt="Profile" src="./profile.jpg" />
                            <FontAwesomeIcon icon={faPlus} className="circle-plus ml-10" />
                        </div>    
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="card">
                        <div className="card-block">
                            <div className="row mb-20">
                                <div className="col-auto">
                                    <span className="rounded-text">MK</span>
                                </div>
                                <div className="col">
                                    <h5 className="m-0 h6">Mukesh Kumar</h5>
                                    <span className="m-0 f-12">Magento Developer</span>
                                </div>
                            </div>
                            <p className="f-14 m-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Card;